export type Status = 'pending' | 'idle' | 'success' | 'error';

export enum AsyncStatus {
  idle = 'idle',
  pending = 'pending',
  success = 'success',
  error = 'error'
}
